const FORMATS = {
  week: "M/DD",
  day: "M/DD",
  year: "YYYY",
  month: "MMM",
  quarter: "MMM",
};

const PICKER_OPTIONS = [
  {
    id: 1,
    label: "Week",
    timeUnit: "week",
    value: "week",
  },
  {
    id: 2,
    label: "Day",
    timeUnit: "day",
    value: "day",
  },
  {
    id: 3,
    label: "Month",
    timeUnit: "month",
    value: "month",
  },
  {
    id: 4,
    label: "Quarter",
    timeUnit: "quarter",
    value: "quarter",
  },
  {
    id: 5,
    label: "Year",
    timeUnit: "year",
    value: "year",
  },
];

export default {
  FORMATS,
  PICKER_OPTIONS,
};
